import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2150584e&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QImg,QDialog,QCard,QCarousel,QCarouselSlide,QBanner,QIcon,QCardSection,QCardActions,QBtn,QSpace,QVideo,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QImg,QDialog,QCard,QCarousel,QCarouselSlide,QBanner,QIcon,QCardSection,QCardActions,QBtn,QSpace,QVideo})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
